import Vue from "vue"
import moment from 'moment'

Vue.filter("asDateTimeString", date =>
    date ? moment(date).format('DD-MMM-YYYY HH:mm').toUpperCase() : ''

)

Vue.filter("makeIDSixDigits", id => {
    let data = 6 - id.toString().length;
    let zero = "";
    for (var i = 0; i < data; i++) {
        zero = zero + "0";
    }
    return zero + id;
})

Vue.filter('formatSize', function (size) {
    if (size > 1024 * 1024 * 1024 * 1024) {
        return (size / 1024 / 1024 / 1024 / 1024).toFixed(2) + ' TB'
    } else if (size > 1024 * 1024 * 1024) {
        return (size / 1024 / 1024 / 1024).toFixed(2) + ' GB'
    } else if (size > 1024 * 1024) {
        return (size / 1024 / 1024).toFixed(2) + ' MB'
    } else if (size > 1024) {
        return (size / 1024).toFixed(2) + ' KB'
    }
    return size.toString() + ' B'
})
Vue.filter('date',function(dateTime){
    let date = moment(dateTime).local()
    return date.format('DD-MMM-Y HH:mm').toUpperCase()
})